import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default class Animations {
    static init() {
        // Animations
        gsap.registerPlugin(ScrollTrigger);

        this.single(document.querySelectorAll('.home .header__title span'), 0);
        this.single(document.querySelector('.home .header__subtitle'), 0.1);
        this.single(document.querySelector('.home .header__description'), 0.1);
        this.single(document.querySelector('.home .header .slider'), 0.6);
        this.single(document.querySelector('.home .footer .slider'), 0);
        this.single(document.querySelector('.header__scroll'), 0.4);
        this.single(document.querySelector('.home .title--h2'), 0.5);
        this.single(document.querySelector('.home .title--h3'), 0);
        this.single(document.querySelector('.section__text'), 0);
        this.single(document.querySelector('.section__cta'), 0);

        this.single(document.querySelectorAll('.title--h2 span'), 0);
        this.single(document.querySelector('.page-template-page-about .header__subtitle'), 0.4);
        this.single(document.querySelectorAll('.header__socialItem'), 0.4);
        this.single(document.querySelector('.page-template-page-about .slider'), 0);

        this.single(document.querySelector('.page-template-default .header__title'), 0);
        this.single(document.querySelector('.page-template-default .header .slider'), 0.1);
        this.single(document.querySelector('.page-template-default .footer .slider'), 0);

        this.multiple(document.querySelectorAll('.project__item'), 0);
        this.multiple(document.querySelectorAll('.page-template-default .section__content.rte *'), 0);
    }

    static single(elt, cDelay) {
        if (elt) {
            gsap.from(
                elt,
                {
                    opacity: 0,
                    duration: 1.25,
                    ease: 'power2.out',
                    y: 60,
                    delay: cDelay,
                    stagger: 0.1,
                    scrollTrigger: {
                        trigger: elt,
                        start: 'top 95%'
                    },
                }
            );
        }
    }

    static multiple(elts) {
        if (elts.length > 0) {
            elts.forEach((elt) => {
                gsap.from(
                    elt,
                    {
                        opacity: 0,
                        duration: 1.25,
                        ease: 'power2.out',
                        y: 60,
                        scrollTrigger: {
                            trigger: elt,
                            start: 'top 90%'
                        },
                    }
                );
            });
        }
    }
}